export default "__VITE_ASSET__BJZrsfFC__"